var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8203 10.4424L11.6133 10.0596C11.9141 10.6885 12.3242 11.2627 12.8164 11.7275C13.7461 10.5791 14.293 9.10254 14.293 7.48926C14.293 5.90332 13.7461 4.42676 12.8164 3.27832C12.3242 3.74316 11.9414 4.29004 11.6407 4.8916L10.8477 4.50879C11.2032 3.79785 11.668 3.16895 12.2422 2.62207C11.0117 1.44629 9.37112 0.708008 7.53909 0.708008C5.70706 0.708008 4.03909 1.44629 2.80862 2.62207C3.38284 3.16895 3.84769 3.79785 4.20316 4.50879L3.41019 4.8916C3.10941 4.29004 2.72659 3.74316 2.23441 3.27832C1.30472 4.42676 0.757843 5.90332 0.757843 7.48926C0.757843 9.10254 1.30472 10.5791 2.23441 11.7275C2.72659 11.2354 3.13675 10.6885 3.43753 10.0596L4.2305 10.4424C3.87503 11.1807 3.41019 11.8096 2.83597 12.3838C4.03909 13.5596 5.70706 14.2705 7.53909 14.2705C9.34378 14.2705 11.0117 13.5596 12.2149 12.3838C11.6407 11.8369 11.1758 11.1807 10.8203 10.4424ZM4.58597 9.56738L3.73831 9.32129C4.14847 8.03613 4.09378 6.75098 3.73831 5.65723L4.55862 5.38379C4.96878 6.61426 5.05081 8.09082 4.58597 9.56738ZM10.4922 5.38379L11.3125 5.65723C10.9571 6.75098 10.9024 8.03613 11.3125 9.32129L10.4649 9.59473C10 8.11816 10.0821 6.61426 10.4922 5.38379Z",
    fill: "#090F25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.85701d6282650537f3349b1f8ca305ab.svg";
export { ForwardRef as ReactComponent };